enum ETipoAcessoAplicacao {
  INTERNO = 'INTERNO',
  EXTERNO = 'EXTERNO',
}

export default ETipoAcessoAplicacao;
